const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.25,
  y: 0.25,
  width: 6.5,
  height: 8.5,
  transform: "matrix(1 0 0 -1 21 24.5)",
  stroke: "#0081CC",
  strokeWidth: 0.5
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.69769 18.6787C5.62621 18.6787 5.54282 18.6318 5.44751 18.5379C5.3522 18.444 5.29859 18.3618 5.28667 18.2913C5.27476 18.2209 5.45942 18.0448 5.84066 17.7631C6.22189 17.4813 6.61504 17.1879 7.02011 16.8826C7.42517 16.5774 7.65153 16.4072 7.69918 16.372C7.72301 16.3485 7.7528 16.3368 7.78854 16.3368H7.80641C7.87789 16.3368 7.96128 16.4366 8.05659 16.6361C8.1519 16.8357 8.47357 17.5224 9.0216 18.6963C9.24796 19.2011 9.43262 19.6061 9.57558 19.9114L11.0946 23.169C11.1065 23.169 11.726 21.9188 12.9531 19.4183C14.1802 16.9179 15.4073 14.3998 16.6344 11.8641C17.8615 9.32847 18.4989 8.03129 18.5465 7.9726C18.618 7.80825 18.7372 7.72607 18.9039 7.72607C18.9873 7.72607 19.0588 7.76129 19.1184 7.83173C19.178 7.90216 19.2197 7.9726 19.2435 8.04303V8.14869L10.8801 25.2116C10.8325 25.2938 10.7193 25.3349 10.5406 25.3349C10.4334 25.3349 10.3619 25.3173 10.3261 25.282C10.3023 25.2586 9.71854 24.0142 8.57484 21.549L6.85927 17.8511L6.57335 18.0448C6.39464 18.1857 6.20998 18.3266 6.01936 18.4674C5.82874 18.6083 5.72152 18.6787 5.69769 18.6787Z",
  fill: "#0C2846"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.7597 8.78278H18.6663V7.72625H28.7597V8.78278Z",
  fill: "#0C2846"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.69769 18.6787C5.62621 18.6787 5.54282 18.6318 5.44751 18.5379C5.3522 18.444 5.29859 18.3618 5.28667 18.2913C5.27476 18.2209 5.45942 18.0448 5.84066 17.7631C6.22189 17.4813 6.61504 17.1879 7.02011 16.8826C7.42517 16.5774 7.65153 16.4072 7.69918 16.372C7.72301 16.3485 7.7528 16.3368 7.78854 16.3368H7.80641C7.87789 16.3368 7.96128 16.4366 8.05659 16.6361C8.1519 16.8357 8.47357 17.5224 9.0216 18.6963C9.24796 19.2011 9.43262 19.6061 9.57558 19.9114L11.0946 23.169C11.1065 23.169 11.726 21.9188 12.9531 19.4183C14.1802 16.9179 15.4073 14.3998 16.6344 11.8641C17.8615 9.32847 18.4989 8.03129 18.5465 7.9726C18.618 7.80825 18.7372 7.72607 18.9039 7.72607C18.9873 7.72607 19.0588 7.76129 19.1184 7.83173C19.178 7.90216 19.2197 7.9726 19.2435 8.04303V8.14869L10.8801 25.2116C10.8325 25.2938 10.7193 25.3349 10.5406 25.3349C10.4334 25.3349 10.3619 25.3173 10.3261 25.282C10.3023 25.2586 9.71854 24.0142 8.57484 21.549L6.85927 17.8511L6.57335 18.0448C6.39464 18.1857 6.20998 18.3266 6.01936 18.4674C5.82874 18.6083 5.72152 18.6787 5.69769 18.6787Z",
  stroke: "#0C2846",
  strokeWidth: 0.5
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.7597 8.78278H18.6663V7.72625H28.7597V8.78278Z",
  stroke: "#0C2846",
  strokeWidth: 0.5
});

const SvgEquationRadicalsFractions3 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationRadicalsFractions3, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-radicals-fractions-3.f92438ae.svg";
export { ForwardRef as ReactComponent };